<div class="registration-container">
    <div [ngClass]="{'registration-request': true}" *ngIf="!success">
        <h1>Request account</h1>
        <p class="logbook-help">
            Logbook is the collaboration platform that helps air transport teams connect, share information and drive
            productivity.
            <br>
            To experience all of the benefits yourself, get free access to Logbook now by simply creating an account and
            start collaborating instantly!
        </p>
        <p *ngIf="invitation && !invitation.error" class="invitation-message">
            Hello <b>{{invitation?.guest}}</b>, you have been invited to join the team <b>{{invitation?.hostCommunityName}}</b>
            on Logbook.<br/>
            To complete your invitation, please fill out the form below
        </p>
        <p *ngIf="invitation && invitation?.error" class="invitation-message-error">
            <span *ngIf="invitation?.error?.status === 400; else other_error">
                Your invitation link has expired. Maybe you <a routerLink="/">already have an account ?</a><br/>
                If not, ask someone to reinvite you or fill out the form below to create an account.
            </span>
            <ng-template #other_error>
                There is a problem with your invitation link.<br/>
                Try again later or create an account by completing the form below.
            </ng-template>
        </p>
        <form [formGroup]="userForm" (ngSubmit)="register()">
            <div class="login-information">
                <div class="title">
                    <span><i class="dln-icon-key"></i></span>
                    Log-in information
                </div>
                <dln-input
                        label="Email"
                        type="email"
                        inputName="email"
                        [errorMessages]="{
                        'userAlreadyExists': 'This account already exists',
                        'isEmail': 'This is not an email'
                        }"
                        [required]="true"
                        [control]="email">
                </dln-input>
                <dln-input
                        label="Password"
                        type="password"
                        inputName="password"
                        [errorMessages]="{
                        'required': 'You need a password',
                        'minlength': 'Your password is required to be at least 4 characters'
                        }"
                        [required]="true"
                        [control]="password">
                </dln-input>
                <mat-checkbox [formControl]="cgvAccepted" [color]="'accent'">
                    <div class="cgu">
                        I agree and i accept the
                        <a [href]="userAgreementUrl" target="_blank">user agreement</a>
                        <span> and </span>
                        <a [href]="privacyPolicyUrl" target="_blank">privacy policy</a>
                    </div>
                </mat-checkbox>
            </div>

            <div [ngClass]="{'submit-container': true, 'loading': loadingForm}">
                <dln-button [type]="'submit'" [isDisabled]="userForm.invalid"
                            [isLoading]="loadingForm" [isLoadingLabel]="'Sending request...'"
                            height="45px"
                            [label]="'Send account request'">
                </dln-button>
            </div>
            <div class="alert" *ngIf="error">
                {{error}}
            </div>
        </form>
        <div class="logbook-features">
            <h2>Why you should join Logbook ?</h2>
            <ul>
                <li>
                    <img class="request-sent" src="../../../content/images/registration/analytics-icon-blue.svg"
                         alt="Manage your team" title="Manage your team"/>
                    <span>Manage your team more efficiently by gaining access to all instructions you’ve been sent</span>
                </li>
                <li>
                    <img class="request-sent" src="../../../content/images/registration/export-icon-blue.svg"
                         alt="Respond to instructions" title="Respond to instructions"/>
                    <span>Respond to instructions quickly and effectively with greater accessibility and searchability to instructions and events through a single, centralized platform</span>
                </li>
                <li>
                    <img class="request-sent" src="../../../content/images/registration/team-icon-blue.svg"
                         alt="Send, share across teams" title="Send, share across teams"/>
                    <span>Send, share and acknowledge instructions across teams through a plug and play, intuitive collaboration tool</span>
                </li>
            </ul>
        </div>
    </div>
    <dln-registe-confirm *ngIf="success"></dln-registe-confirm>
</div>




